import React, { useState } from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { ExecutiveSummary } from '../components/ExecutiveSummary';
import { CompanyBackground } from '../components/CompanyBackground';
import { ImageBanner } from '../components/ImageBanner';
import { VisionMission } from '../components/VisionMission';
import { Values } from '../components/Values';
import { Products } from '../components/Products';
import { QualityStandards } from '../components/QualityStandards';
import { LegalCompliance } from '../components/LegalCompliance';
import { Partnership } from '../components/Partnership';
import { Market } from '../components/Market';
import { Contact } from '../components/Contact';
import { QuoteModal } from '../components/QuoteModal';
export function LandingPage() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  const openQuoteModal = () => setIsQuoteModalOpen(true);
  const closeQuoteModal = () => setIsQuoteModalOpen(false);
  return <div className="min-h-screen w-full bg-white scroll-smooth" data-id="element-304">
      {/* SEO Meta Tags */}
      <SEO data-id="element-305" />

      {/* Navigation */}
      <Navbar onOpenQuoteModal={openQuoteModal} data-id="element-306" />

      {/* Main Content */}
      <main data-id="element-307">
        <Hero onOpenQuoteModal={openQuoteModal} data-id="element-308" />
        <ExecutiveSummary data-id="element-309" />
        <CompanyBackground data-id="element-310" />
        <ImageBanner data-id="element-311" />
        <VisionMission data-id="element-312" />
        <Values data-id="element-313" />
        <Products data-id="element-314" />
        <QualityStandards data-id="element-315" />
        <LegalCompliance data-id="element-316" />
        <Partnership data-id="element-317" />
        <Market data-id="element-318" />
        <Contact data-id="element-319" />
      </main>

      {/* Quote Modal */}
      <QuoteModal isOpen={isQuoteModalOpen} onClose={closeQuoteModal} data-id="element-320" />
    </div>;
}